export default __webpack_public_path__ + "static/media/4.128dd6c1.jpg";